import { useEffect, useState } from "react";

function pad(n: number) {
  return n.toString().padStart(2, "0");
}

export default function Hero() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  const clock = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
  const dateText = `${now.getFullYear()} 年 ${now.getMonth() + 1} 月 ${now.getDate()} 日`;

  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20banner%20with%20layered%20warm%20coral%20red%2C%20fresh%20green%20and%20honey%20amber%20translucent%20shapes%2C%20soft%20grain%20texture%2C%20dynamic%20diagonal%20composition%2C%20modern%20magazine%20cover%20feel%2C%20no%20text&width=1600&height=900&seq=gt-hero-bg-01&orientation=landscape"
          alt="瓜田速递实时快讯时间线主题背景"
          className="w-full h-full object-cover object-top"
          title="瓜田速递实时快讯 24小时滚动更新"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-16 pb-20 md:pt-24 md:pb-28">
        <div className="max-w-3xl mx-auto text-center flex flex-col items-center">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-background-50/15 border border-background-50/25 text-background-50 text-xs md:text-sm backdrop-blur-sm">
            <span className="relative flex w-2 h-2">
              <span className="absolute inline-flex w-full h-full rounded-full bg-accent-400 animate-pulse-dot"></span>
              <span className="relative inline-flex w-2 h-2 rounded-full bg-accent-400"></span>
            </span>
            24 小时滚动更新中 · 刚刚又更新了 3 条快讯
          </span>

          <h1 className="mt-6 font-heading text-4xl md:text-6xl text-background-50 leading-tight">
            吃瓜不迷路
            <span className="block text-primary-300 mt-1">正在发生的动静，都在这儿</span>
          </h1>

          <p className="mt-5 text-sm md:text-base text-background-200 leading-relaxed max-w-2xl">
            瓜田速递快讯推送把正在发生的动静按时间线提到最前面。实时快报区点开就能看到当前讨论、网友配套截图和后续发酵走向，
            不用再满网追着跑，打开这一页就够。
          </p>

          <div className="mt-8 w-full flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
            <a
              href="#live"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-flashlight-fill w-5 h-5 flex items-center justify-center" aria-hidden="true"></i>
              看实时快报
            </a>
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 border border-background-50/30 text-background-50 text-sm font-medium hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-notification-3-line w-5 h-5 flex items-center justify-center" aria-hidden="true"></i>
              订阅快讯推送
            </a>
          </div>
        </div>

        <div className="mt-12 md:mt-16 max-w-4xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-px rounded-lg overflow-hidden bg-background-50/15 border border-background-50/20 backdrop-blur-sm">
          <div className="bg-black/25 px-4 py-4 text-center">
            <p className="font-heading text-2xl md:text-3xl text-background-50">128</p>
            <p className="mt-1 text-xs text-background-300">今日已更新快讯</p>
          </div>
          <div className="bg-black/25 px-4 py-4 text-center">
            <p className="font-heading text-2xl md:text-3xl text-accent-300">24h</p>
            <p className="mt-1 text-xs text-background-300">全天滚动不停更</p>
          </div>
          <div className="bg-black/25 px-4 py-4 text-center">
            <p className="font-heading text-2xl md:text-3xl text-background-50">5</p>
            <p className="mt-1 text-xs text-background-300">覆盖主题板块</p>
          </div>
          <div className="bg-black/25 px-4 py-4 text-center">
            <p className="font-heading text-2xl md:text-3xl text-secondary-300 tabular-nums">{clock}</p>
            <p className="mt-1 text-xs text-background-300">{dateText} · 当前时间</p>
          </div>
        </div>
      </div>
    </section>
  );
}